import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { CommonUtil } from '../../core/Utils/common-util';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { CountriesService } from 'src/app/core/services/countries.service';
import { Subscription } from 'rxjs';
import { SubscriptionService } from 'src/app/post-login/services/subscription.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { FacilityDetailsService } from '../services/facility-details.service';
import { FlagObject } from 'src/app/core/halo-tips/halo-tips.model';
import { DashboardAdHintService } from './dashboard-ad-hint/dashboard-ad-hint.service';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  @ViewChild('heatMapSnapShot', { static: false }) heatMapSnapShotRef: ElementRef;
  @ViewChild('heatMap', { static: false }) heatMapRef: ElementRef;
  contentData: any = {};
  contentData2: any = {};
  contentData3: any = {};
  multisiteData: any = {};

  welcomeName: string = '';
  staticMapURL: string = '';
  facilityhourstxt: string = '';
  currentFacility: FacilityObject;
  LFOnDemandConsoles = ['superman', 'hal'];
  reloadEnrolled: boolean = false;
  manageFacilityHint: string;
  dashboardAdOpen: boolean = false;
  contentManagerBannerOpen: boolean = false;
  digitalCoachAdOpen: boolean = false;
  digitalCoachBannerOpen: boolean = false;
  isShowLFODBanner = false;
  product: string;
  popupData: any = {};
  cloudBasePath: string;
  dashboardAdHintImages = {lfodPremium: '/Images/Image_SubscribeTips_LFODPremium.png', digitalCoach: '/Images/Image_Subscription_DigitalCoach.png',videoLibrary:'/Images/Image_VideoLibrary_Tip.png'} as any;
  dashboardAdHintDescriptions = {lfodPremium: 'LF.ON.DEMAND.PREMIUM.DASHBOARD.TOOLTIP.MSG', digitalCoach: 'DIGITAL.COACH.DASHBOARD.TOOLTIP.MSG',videoLibrary:'LF.ON.DEMAND.PREMIUM.VIDEOLIBRARY.DASHBOARD.TOOLTIP.MSG'} as any;
  // subscriptions
  private _facilityOnChange: Subscription;
  private hasFullPermission: boolean = false;

  constructor(
    private rootScopeService: RootScopeService,
    public commonUtil: CommonUtil,
    private router: Router,
    private _facilityService: FacilityService,
    private _countriesService: CountriesService,
    private _loader: HaloLoaderService,
    private _subscriptionService: SubscriptionService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private facilityDetailService: FacilityDetailsService,
    private _hints: DashboardAdHintService ,
    private featureService: FeatureFlagsService
  ) { }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
      if (rootScopeData.currentUser) {
        this.welcomeName = this.commonUtil.replaceValueAsHTMLOnTranslatedText('WELCOME', [
          this.rootScopeData.currentUser.displayName,
        ]);
      }
    });
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'dashboard';
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();
    this.setPageName();
    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this.manageFacilityHint = this._facilityService.getManageFacilityHint();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this.resetDashboardData();
      this._hints.onDismissed();
    });
    this.popupData = this._facilityService.getAnnouncements() || {};
    if (this.rootScopeData.popupData.showDigitalCoachDashboardBanner == undefined)
      this.rootScopeData.popupData.showDigitalCoachDashboardBanner = this.popupData.showDigitalCoachDashboardBanner;    

    if (this.currentFacility['facilityId']) {
      this.resetDashboardData();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
    this._hints.onDismissed();
  }

  callContentAction(contentType: string) {
    if (contentType === 'cardioondemand') this.router.navigate(['/equipmentSettings/lifeFitnessOnDemand']);
    if (contentType === 'equipmentDistancing')
      this.router.navigate(['/equipmentSettings/healthSafety/equipmentDistancing']);
    if (contentType === 'subscriptions') {
      this._loader.startProcess();
      //this._amplitudeAnalytics.logEvent('Store', { from: 'FacilityBanner' });
      this._facilityService
        .setFacilityUserPreference('isSubscriptionBannerEnabled', false)
        .then()
        .finally(() => {
          this._subscriptionService.getToken();
          this._loader.endProcess();
        });
    }
    if(contentType==='manageFacility')this.router.navigate(['/facility/manage']);
  }

  resetDashboardData() {
    if (this.currentFacility.summary.facilityRights.home != 'true') {
      this.commonUtil.redirectToAvailablePage();
    }

    this.hasFullPermission = this.currentFacility.summary.userRights.facility === 'F' || this.currentFacility.summary.isLoggedInManagerAdmin === 'true';
    this.dashboardAdOpen = this.currentFacility
      && this.currentFacility.summary
      && this.currentFacility.summary.userRights.isAdmin === 'true'
      && this.currentFacility.summary.isPlanetFitness !== 'true';
    this.contentManagerBannerOpen = this.currentFacility
      && this.currentFacility.hasOwnProperty('summary')
      && this.currentFacility.summary.hasOwnProperty('facilityRights')
      && (this.currentFacility.summary.facilityRights.customLibrary === 'true')
      && this.currentFacility.summary.userRights.customLibrary != 'H'
      && this.featureService.isOn('poseidon-milestone-3');
    this.digitalCoachBannerOpen = this.currentFacility
      && this.currentFacility.hasOwnProperty('summary')
      && this.currentFacility.summary.hasOwnProperty('facilityRights')
      && (this.currentFacility.summary.facilityRights.digitalCoach === 'true')
      && this.currentFacility.summary.userRights.digitalCoach != 'H'
      && this.rootScopeData.popupData.showDigitalCoachDashboardBanner;
    this.digitalCoachAdOpen = this.popupData.showDigitalCoachAnnouncementPopup
      && this.currentFacility
      && this.currentFacility.hasOwnProperty('summary')
      && this.currentFacility.summary.hasOwnProperty('facilityRights')
      && this.currentFacility.summary.facilityRights.digitalCoach === 'false'
      && this.currentFacility.summary.userRights.digitalCoach != 'H'
      && this.currentFacility.summary.isDigitalCoachEligible === 'true';
    this.isShowLFODBanner = this.currentFacility?.summary?.hasLFODEnabledSetup === 'true' 
      && this.currentFacility?.summary?.userRights.lfodEnabledEquipment !== 'H' 
      && this.featureService.isOn('se3HD');
      
    this.setUpFacilityMap();
    this.setUpHealthandSafetyBanner();
    this.setUpSubscriptionBanner();
    this.setUpMultisiteBanner();

    //await the dashboard component rendering to be completed.
    setTimeout(() => {
      this.loadAdHintTooltips();
    }, 2000);
   
  }

  loadAdHintTooltips(){
    //Show VideoLibrary Ad Tooltip.
    if(this.rootScopeData.popupData.showVideoLibraryTooltip && this.rootScopeData.popupData.showVideoLibraryTooltip === 'true'){
      const adhint = {
        flag:'showVideoLibraryTooltip',
        key: 'video_library_AdHint',
        dismissable:true,
        skipable:false,
        cloudBasePath : this.cloudBasePath,
        dashboardAdDescriptions:this.commonUtil.translateText(this.dashboardAdHintDescriptions['videoLibrary']),
        dashboardAdImages:this.dashboardAdHintImages['videoLibrary'],
        position:'right'
      };
      this._hints.add([adhint]);
    }


  }

  /*facility map start*/
  setUpFacilityMap(): void {
    let curFacSummary = this.currentFacility.summary;
    this.facilityhourstxt = this.commonUtil.getFormattedFacilityHours(curFacSummary);
    let addressToMap = `${curFacSummary.address}, ${curFacSummary.city}, ${curFacSummary.state}, ${curFacSummary.postalCode
      }, ${this._countriesService.getCountry(curFacSummary.countryIsoCode)}`;
    addressToMap = addressToMap.replace(/\#/g, '');
    this.staticMapURL =
      'https://maps.googleapis.com/maps/api/staticmap?center=' +
      addressToMap +
      '&zoom:9&size=240x240&maptype=roadmap&markers=color:red|' +
      addressToMap +
      '&key=AIzaSyDASRb62z1lI4jZZg4P7HkJwb7U-VUZ0HE';
  }


  gotoEditFacilityScreen(): void {
    localStorage.setItem('goToEditFacility', 'true');
    this.router.navigate(['/facility/manage/edit']);
  }
  /*facility map end*/

  setUpSubscriptionBanner() {
    if (
      this.currentFacility.summary.isProEnabled === 'true' &&
      this.currentFacility.summary.isOptedIn === 'false' &&
      this.currentFacility.summary.isSubscriptionBannerEnabled === 'true'
    ) {
      this.contentData3.visible = true;
      this.contentData3.title = 'SUBSCRIPTION.BANNER.HEADER';
      this.contentData3.titleNew = 'NEW';
      this.contentData3.htmlMessage = this.commonUtil.translateText('SUBSCRIPTION.BANNER.CONTENT');

      this.contentData3.buttonText = 'VIEW';
      this.contentData3.contentAction = 'subscriptions';
      this.contentData3.banner = true;
    } else {
      this.contentData3.visible = false;
    }
  }

  setUpHealthandSafetyBanner() {
    if (
      this.currentFacility.summary.facilityRights.healthSafety == 'true' &&
      this.currentFacility.summary.hasHealthSafetySetup == 'false' 
    ) {
      this.contentData2.visible = true;
      this.contentData2.title = 'HEALTH.SAFETY.CUSTOMIZE.BANNER.HEADER';
      this.contentData2.titleNew = 'NEW';
      this.contentData2.htmlMessage = this.commonUtil.translateText('HEALTH.SAFETY.CUSTOMIZE.BANNER.CONTENT');

      this.contentData2.buttonText = 'CUSTOMIZE.NOW';
      this.contentData2.contentAction = 'equipmentDistancing';
      this.contentData2.banner = true;
    } else {
      this.contentData2.visible = false;
    }
  }

   setUpMultisiteBanner() {
    if (this.manageFacilityHint === 'true') {
      this.multisiteData.visible = true;
      this.multisiteData.title = 'MANAGE.FACILITY.BANNER.HEADER';
      this.multisiteData.titleNew = 'NEW';
      this.multisiteData.htmlMessage = this.commonUtil.translateText('MANAGE.FACILITY.BANNER.CONTENT');

      this.multisiteData.buttonText = 'MANAGE.FACILITIES';
      this.multisiteData.contentAction = 'manageFacility';
      this.multisiteData.banner = true;
    } else {
      this.multisiteData.visible = false;
    }
  }

  getLfOnDemandConsoles() {
    let supportedConsolesTxt: string = '';
    let supportedConsoles: Array<string> = [];
    if (this.currentFacility.consoleEquipments) {
      for (var j = 0; j < this.currentFacility.consoleEquipments.length; j++) {
        if (this.LFOnDemandConsoles.indexOf(this.currentFacility.consoleEquipments[j].consoleType) > -1) {
          supportedConsoles[supportedConsoles.length] = this.rootScopeData.consoleRights.get(
            this.currentFacility.consoleEquipments[j].consoleType
          ).consoleName;
        }
      }
      supportedConsolesTxt = supportedConsoles
        .join(', ')
        .replace(/,(?!.*,)/gim, ' ' + this.commonUtil.translateText('AND'));
    }
    return supportedConsolesTxt;
  }

  reloadEnrolledSection(): void {
    this.reloadEnrolled = true;
  }

  resetReloadRequired(): void {
    this.reloadEnrolled = false;
  }

  goToDigitalCoach(): void {
    this.router.navigate(['/digital_coach']);
  }

  goToEnabledEquipment(): void {
    this.router.navigate(['/enable_equipment']);
  }

  closeDashboardAd(item: string) {
    this.product = item;
    this.dashboardAdOpen = false;
    const flagsToUpdate: FlagObject = {};
    if (this.popupData
      && this.popupData.showDigitalCoachAnnouncementPopup
      && this.currentFacility.summary.isDigitalCoachEligible === 'true') {
      flagsToUpdate['showDigitalCoachAnnouncementPopup'] = false;
      this.popupData.showDigitalCoachAnnouncementPopup = false;
    }
    if (Object.keys(flagsToUpdate).length > 0)
      this._facilityService.updatedFacilityPreferenceForUser(flagsToUpdate);
    this.rootScopeService.updateRootScope(this.rootScopeData);
    const adHint = {
      flag:'', // flag is empty , not to trigger any api call.
      key: 'subscription_AdHint',
      dismissable:true,
      skipable:false,
      cloudBasePath : this.cloudBasePath,
      dashboardAdDescriptions:this.commonUtil.translateText(this.dashboardAdHintDescriptions[this.product]),
      dashboardAdImages:this.dashboardAdHintImages[this.product],
      position:'right'
    };
    this._hints.add([adHint]);
  }
}
